/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Action_Ai_TailorInputs */

const en_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Tailor`)
};

const de_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Anpassung`)
};

const fr_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptation IA`)
};

const es_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adaptación IA`)
};

const it_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizza con AI`)
};

const nl_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI op maat`)
};

const pl_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostosuj AI`)
};

const fi_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-mukautus`)
};

const da_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-tilpasning`)
};

const sv_dashboard_action_ai_tailor = /** @type {(inputs: Dashboard_Action_Ai_TailorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Anpassa`)
};

/**
* | output |
* | --- |
* | "AI Tailor" |
*
* @param {Dashboard_Action_Ai_TailorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_action_ai_tailor = /** @type {((inputs?: Dashboard_Action_Ai_TailorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Action_Ai_TailorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_action_ai_tailor(inputs)
	if (locale === "fr") return fr_dashboard_action_ai_tailor(inputs)
	if (locale === "es") return es_dashboard_action_ai_tailor(inputs)
	if (locale === "it") return it_dashboard_action_ai_tailor(inputs)
	if (locale === "nl") return nl_dashboard_action_ai_tailor(inputs)
	if (locale === "pl") return pl_dashboard_action_ai_tailor(inputs)
	if (locale === "fi") return fi_dashboard_action_ai_tailor(inputs)
	if (locale === "da") return da_dashboard_action_ai_tailor(inputs)
	if (locale === "sv") return sv_dashboard_action_ai_tailor(inputs)
	return en_dashboard_action_ai_tailor(inputs)
});